/* eslint-disable no-sequences */
<template>
  <div>
    <ContentBox title="发送监测" class="content-box">
      <el-form label-width="90px">
        <el-form-item label="发送监测">
          <el-radio-group v-model="model.trackType">
            <el-radio-button :label="1" :disabled="trackTypeDisable">客户端监测</el-radio-button>
            <el-radio-button :label="2" :disabled="trackTypeDisable">服务端监测</el-radio-button>
          </el-radio-group>
          <span style="padding-left:10px;font-size:12px;color:#999">{{ trackTypeTips }}</span>
        </el-form-item>
      </el-form>
    </ContentBox>
    <ContentBox title="上传计划表格" class="content-box">
      <el-form ref="form" label-width="90px">
        <el-form-item label="计划表格">
          <el-row>
            <el-col :span="10">
              <el-upload ref="instance"
                v-loading="loading"
                action="api/dsp/scheduleBatch/uploadExcel"
                accept=".xlsx"
                name="file"
                :file-list="file"
                :data="{ ...uploadInfo, trackType: model.trackType }"
                :show-file-list="true"
                :on-change="changeFile"
                :on-success="handleUploadSuccess"
                :before-remove="handleBeforeRemove">
                <el-button  size="small" slot="trigger" type="primary" >点击上传</el-button>
                <el-button type="text" style="margin-left: 10px;" size="small">
                  <span style="color:#6e6e6e">仅允许上传.xlsx格式文件，点击这里</span>
                  <a style="color: #e67d00;text-decoration:none" href="./投放计划表格模版.xlsx" download="投放计划表格模版.xlsx">下载模版</a>
                </el-button>
              </el-upload>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </ContentBox>
    <template v-if="tableList.length > 0">
      <template v-if="showAllNone">
        <el-card class="box-card">
          <div style="text-align:center;color: #8c939d;">表格中未包含任何排期，请重新上传</div>
        </el-card>
      </template>
      <template v-else>
        <div v-for="(item,index) in tableList" :key="'t'+index" style="margin-top: 12px;">
          <el-card v-if="item.code === 0" class="box-card">
            <div slot="header" class="clearfix">
              <span>{{item.title}}</span>
              <span style="float: right; padding: 3px 0" type="text"> 共&nbsp;{{item.data.length}}&nbsp;条</span>
            </div>
            <el-form class="cc-form2" ref="form" labelWidth="0" >
              <el-form-item style="color: red;" v-for="(m,index) in item.message" :key="'t'+index">{{m}}</el-form-item>
              <el-form-item class="cc-form2--formItem" >
                <div class="cc-form2-box">
                  <el-table
                    :data="item.data"
                    :border="true"
                    max-height="700"
                    fit
                    tooltip-effect="dark"
                    style="width: 100%">
                    <el-table-column fixed prop="scheduleName" label="计划单名称" min-width="150"></el-table-column>
                    <el-table-column fixed prop="provinceStr" label="省份" :show-overflow-tooltip="true" width="150"></el-table-column>
                    <el-table-column fixed prop="cityStr" label="城市" :show-overflow-tooltip="true" min-width="150"></el-table-column>
                    <el-table-column prop="frequencyValue" label="频控方式" header-align="center" min-width="150">
                      <el-table-column prop="frequencyName" label="周期"></el-table-column>
                      <el-table-column prop="frequency" label="频次"></el-table-column>
                    </el-table-column>
                      <el-table-column prop="subFrequencyValue" label="双周期频控" header-align="center">
                      <el-table-column prop="subFrequencyName" label="周期">
                      </el-table-column>
                      <el-table-column prop="subFrequency" label="频次">
                      </el-table-column>
                    </el-table-column>
                    <el-table-column prop="seq" label="优先级"></el-table-column>
                    <el-table-column prop="mediaIdStr" label="素材ID" min-width="100"></el-table-column>
                    <el-table-column prop="mateCheckCodeStr" label="物料校验码" :show-overflow-tooltip="true" min-width="120"></el-table-column>
                    <el-table-column prop="defaultMediaIdStr" label="打底素材ID" min-width="120"></el-table-column>
                    <el-table-column label="投放总量" header-align="center">
                      <el-table-column prop="trafficTypeStr" label="投放方式" min-width="120"></el-table-column>
                      <el-table-column prop="totalTraffic" label="数量(CPM)" min-width="120"></el-table-column>
                      <el-table-column prop="autoFillingStr" label="自动补量" min-width="120"></el-table-column>
                    </el-table-column>
                    <el-table-column label="售卖价格" header-align="center">
                        <el-table-column prop="sellingPrice" label="价格" min-width="100"></el-table-column>
                        <el-table-column prop="billTypeStr" label="售卖方式" min-width="100"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="payTotalTraffic" label="排期总量"></el-table-column>
                    <el-table-column prop="freeTotalTraffic" label="赠送总量"></el-table-column>
                    <el-table-column prop="addedTotalTraffic" label="补量总量"></el-table-column>
                    <el-table-column prop="erpSubOrder" label="ERP子单号" min-width="150"></el-table-column>
                    <el-table-column prop="suborderNo" label="销售子单号" min-width="180"></el-table-column>
                    <el-table-column prop="dealId" label="dealID" min-width="150"></el-table-column>
                    <el-table-column label="关联频控" header-align="center">
                      <el-table-column prop="scheduleNo" label="关联计划单号" min-width="150">
                      </el-table-column>
                      <el-table-column prop="unionOrderStr" label="顺序控制" min-width="120">
                      </el-table-column>
                      <el-table-column prop="unionFrequency" label="总频次" min-width="100">
                      </el-table-column>
                      <el-table-column prop="subUnionFrequency" label="双周期总频次" min-width="150">
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="TA" header-align="center">
                      <el-table-column prop="taCondition" header-align="left" label="条件" min-width="150">
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="N+UV" header-align="center">
                      <el-table-column prop="uvTarget" label="N+" min-width="100">
                      </el-table-column>
                      <el-table-column prop="uvPercentage" label="指标（百分比）" min-width="120">
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="每日排期量(CPM)" header-align="center" min-width="150">
                      <template v-for="(sitem, sindex) in item.scheduleHeader">
                        <el-table-column :label="sitem" :key="'s'+sindex" width="100" align="center">
                          <template v-for="(ritem, rindex) in item.scheduleDayData">
                            <el-table-column v-if="ritem.month === sitem" :prop="'schedule'+ritem.month+ritem.day" :label="ritem.day" :key="'r'+rindex" width="100">
                            </el-table-column>
                          </template>
                        </el-table-column>
                      </template>
                    </el-table-column>
                    <el-table-column label="每日赠送量(CPM)" header-align="center" min-width="150">
                      <template v-for="(sitem, sindex) in item.extraDayHeader">
                        <el-table-column :label="sitem" :key="'s'+sindex" width="100" align="center">
                          <template v-for="(ritem, rindex) in item.extraDayData">
                            <el-table-column v-if="ritem.month === sitem" :prop="'extra'+ritem.month+ritem.day" :label="ritem.day" :key="'r'+rindex" width="100">
                            </el-table-column>
                          </template>
                        </el-table-column>
                      </template>
                    </el-table-column>
                    <el-table-column label="每日补量(CPM)" header-align="center" min-width="150">
                      <template v-for="(sitem, sindex) in item.addedDayHeader">
                        <el-table-column :label="sitem" :key="'s'+sindex" width="100" align="center">
                          <template v-for="(ritem, rindex) in item.addedDayData">
                            <el-table-column v-if="ritem.month === sitem" :prop="'added'+ritem.month+ritem.day" :label="ritem.day" :key="'r'+rindex" width="100">
                            </el-table-column>
                          </template>
                        </el-table-column>
                      </template>
                    </el-table-column>
<!--                      <el-table-column label="投放时间">-->
<!--                        <template>-->
<!--                          <el-table-column-->
<!--                            v-for="(timeHeader, idx) in item.scheduleTimeHeader"-->
<!--                            :key="idx"-->
<!--                            :prop="timeHeader.prop"-->
<!--                            :label="timeHeader.title"-->
<!--                            width="100"-->
<!--                          ></el-table-column>-->
<!--                        </template>-->
<!--                      </el-table-column>-->
                    <el-table-column prop="case" label="结算代码" header-align="center">
                      <el-table-column prop="cashTrackType" label="结算监测类型" width="140"></el-table-column>
                      <el-table-column prop="cashProviderName" label="结算监测商" width="120"></el-table-column>
                    </el-table-column>
                    <el-table-column label="曝光监测" header-align="center">
                      <el-table-column label="1">
                        <el-table-column prop="show1serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="show1trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="show1code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="2">
                        <el-table-column prop="show2serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="show2trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="show2code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="3">
                        <el-table-column prop="show3serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="show3trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="show3code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="点击监测" header-align="center">
                      <el-table-column label="1">
                        <el-table-column prop="click1serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="click1trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="click1code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="2">
                        <el-table-column prop="click2serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="click2trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="click2code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="3">
                        <el-table-column prop="click3serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="click3trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="click3code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="中点监测" header-align="center">
                      <el-table-column label="1">
                        <el-table-column prop="center1serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="center1trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="center1code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="2">
                        <el-table-column prop="center2serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="center2trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="center2code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="3">
                        <el-table-column prop="center3serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="center3trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="center3code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="起播监测" header-align="center">
                      <el-table-column label="1">
                        <el-table-column prop="start1serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="start1trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="start1code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="2">
                        <el-table-column prop="start2serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="start2trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="start2code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="3">
                        <el-table-column prop="start3serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="start3trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="start3code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="结束监测" header-align="center">
                      <el-table-column label="1">
                        <el-table-column prop="end1serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="end1trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="end1code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="2">
                        <el-table-column prop="end2serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="end2trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="end2code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="3">
                        <el-table-column prop="end3serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="end3trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="end3code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="定点监测" header-align="center">
                      <el-table-column label="1">
                        <el-table-column prop="point1serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="point1trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="point1point" label="时间点"></el-table-column>
                        <el-table-column prop="point1code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="2">
                        <el-table-column prop="point2serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="point2trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="point2point" label="时间点"></el-table-column>
                        <el-table-column prop="point2code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                      <el-table-column label="3">
                        <el-table-column prop="point3serviceProvider" label="监测商" width="100"></el-table-column>
                        <el-table-column prop="point3trackTypeModel" label="方式"></el-table-column>
                        <el-table-column prop="point3point" label="时间点"></el-table-column>
                        <el-table-column prop="point3code" label="代码" :show-overflow-tooltip="true" min-width="300"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </el-form>
          </el-card>
          <el-card v-if="item.code === 1" class="box-card">
            <div slot="header" class="clearfix">
              <span>{{item.title}}</span>
            </div>
            <el-form class="cc-form2" ref="form" labelWidth="0" >
              <el-form-item style="color: red;" v-for="(m,index) in item.message" :key="'m'+index">{{m}}</el-form-item>
            </el-form>
          </el-card>
        </div>
      </template>
    </template>
    <el-form class="cc-form2" ref="creativeForm" :model="model" label-position="left" labelWidth="110px" >
      <ContentBox title="投放时间" class="content-box" v-if="model.batchTimeList.length">
        <div v-for="(item, ind) in model.batchTimeList" :key="ind">
          <el-form-item :label="item.title">
            <el-radio-group v-model="item.dateType" @change="dateTypeHandle">
              <el-radio-button :label="0">全天</el-radio-button>
              <el-radio-button :label="1">自定义</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <template v-if="item.dateType === 1">
            <el-form-item
              v-for="(batchTime, index) in item.timeList"
              :key="'t' + index"
              :prop="'batchTimeList.' + ind + '.timeList.' + index + '.timeDay'"
              :rules="batchTimeListRules.timeDay"
            >
              <div class="flex-form-item">
                <el-date-picker
                  :value="batchTime.timeDay"
                  type="daterange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  class="c-date-picker"
                  value-format="yyyy-MM-dd"
                  @change="validateHandle()"
                  @input="handleInputPutTime(ind, index, $event)"
                ></el-date-picker>
                <el-time-picker
                  v-model="batchTime.timeHours"
                  :disabled="batchTime.disabled"
                  is-range
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  class="c-date-picker"
                  value-format="HH:mm:ss"
                  @change="validateHandle()"
                ></el-time-picker>
                <div>
                  <i class="selIcon el-icon-circle-plus-outline" @click="handleAddTimePicker(ind)"></i>
                  <i v-if="item.timeList.length > 1" class="selIcon el-icon-remove-outline" @click="handleDeleteTimePicker(ind, index)"></i>
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-link :underline="false" type="primary" @click="weekHandle(ind)">按工作日&周末拆分</el-link>
            </el-form-item>
          </template>
        </div>
      </ContentBox>
      <ContentBox v-if="showTargetEvent" title="交互事件" class="content-box">
        <!-- 交互事件，根据广告位配置是否支持交互事件显示 -->
        <el-form-item label="交互事件">
          <el-radio-group v-model="model.shipType" @change="handleShipTypeChange">
            <el-radio-button label="NONE">无</el-radio-button>
            <el-radio-button v-for="event in eventOptions" :key="event.shipType" :label="event.shipType">{{ event.name }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="model.shipType !== 'NONE'">
          <TargetEventItem
            :partnerId="baseInfo.partnerId"
            :ship-type="model.shipType"
            :model="model.targetEvent"
            :eventTempList="eventTempList"
            @temp-change="handleTargetEventChange"
          />
        </el-form-item>
        <template v-if="uploadInfo.supportMode === 2">
          <el-form-item label="打底交互事件">
            <el-radio-group v-model="model.backupShipType" @change="handleBackupShipTypeChange">
              <el-radio-button label="NONE">无</el-radio-button>
              <el-radio-button v-for="event in eventOptions" :key="event.shipType" :label="event.shipType">{{ event.name }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="model.backupShipType !== 'NONE'">
            <TargetEventItem
              :partnerId="baseInfo.partnerId"
              :ship-type="model.backupShipType"
              :model="model.backupTargetEvent"
              :eventTempList="eventTempList"
            />
          </el-form-item>
        </template>
      </ContentBox>
      <ContentBox v-if="adSpaceModel.supportFeedContent === 1" title="附加创意" class="content-box">
        <el-row>
          <el-col :span="16">
            <el-form-item label="创意标题" prop="creativeTitle" :rules="[{ required: true, trigger: 'blur', message: '创意标题不能为空' }]">
              <el-input
                v-model="model.creativeTitle"
                clearable
                show-word-limit
                placeholder="请输入创意标题"
                :maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="model.shipType === 'KEY' && model.targetEvent && model.targetEvent.targetTempId > -1">
          <el-col :span="8">
            <el-form-item label="点击按钮文案" prop="clickButtonContent" :rules="[{ required: true, trigger: 'blur', message: '点击按钮文案不能为空' }]">
              <el-input
                v-model="model.clickButtonContent"
                clearable
                show-word-limit
                placeholder="请输入点击按钮文案，例如：查看详情、立即购买"
                :maxlength="6"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </ContentBox>
      <ContentBox title="提示语" class="content-box">
        <el-row>
          <el-col :span="22">
            <el-form-item label="提示语">
              <AdTipsEditorNew
                ref="tipsEditor"
                :tipsTempId="model.tipsTempId"
                :tipsDetail="model.tipsDetail"
                :spaceId="uploadInfo ? uploadInfo.spaceId : 0"
                :targetEventType="model.targetEventType"
                @change-tips="saveTips"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </ContentBox>
      <ContentBox title="扩展参数" class="content-box">
        <el-form-item label="扩展参数">
          <el-radio-group v-model="extendParamType" @change="handleExtendParamChange">
            <el-radio-button :label="0">无</el-radio-button>
            <el-radio-button :label="1">配置</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </ContentBox>
    </el-form>
    <el-dialog
      title="按工作日&周末拆时段"
      width="750px"
      custom-class="period-dialog"
      destroy-on-close
      :visible.sync="dialogWeekVisible"
      :close-on-click-modal="false"
    >
      <div>
        <PeriodTimePicker @dateChange="handleSelectPeriod"  :curDateList="curDateList" />
      </div>
      <div slot="footer">
        <el-button type="plain" @click="dialogWeekVisible = false">取消</el-button>
        <el-button type="primary" @click="savePeriodTime">保存</el-button>
      </div>
    </el-dialog>
    <ContentBox  class="content-box" style="margin-top: 12px;">
      <el-button @click="previous()">上一步</el-button>
      <el-button type="primary" @click="next()">下一步</el-button>
    </ContentBox>
  </div>

</template>
<script>
import AdTipsEditorNew from '@/components/media/AdTipsEditorNew.vue'
import TargetEventItem from '@/components/targetEvent/TargetEventItem.vue'
import PeriodTimePicker from '@/components/common/PeriodTimePicker.vue'
import { genTargetEvent, eventOptions } from '@/views/advertisement/creative/MaterialCreative'
import { checkPutTime, handleFormTimeList, dateSplitList, getBetweenDate } from '@/components/schedule/utils'
import { flatten } from 'lodash'
import moment from 'moment'

export default {
  components: {
    AdTipsEditorNew,
    TargetEventItem,
    PeriodTimePicker
  },
  props: {
    uploadInfo: Object,
    baseInfo: Object,
    adSpaceModel: Object
  },
  watch: {
    baseInfo: {
      handler(newValue, oldValue) {
        if (typeof newValue !== 'object' || !newValue) {
          return
        }
        if (newValue.isBaseInfoChange) {
          this.isChangeModel = true
          this.file = []
          this.tableList = []
        }
        if (newValue.isSpaceChange) {
          this.$service.getAdDefaultTip({ spaceId: newValue.spaceId, defFlagType: 0 }).then((res) => {
            if (res) {
              this.model.targetEventType = 4
              this.model.tipsTempId = res.tempId
              this.model.tipsDetail = res.tipsDetail ? this.filterDefaultTips(res.tipsDetail) : ''
            } else {
              this.model.tipsTempId = undefined
              this.model.tipsDetail = ''
            }
          })
        }
        if (this.baseInfo.trackTypeList) {
          this.model.trackType = this.trackTypeList.length === 1 ? parseInt(this.trackTypeList[0].key) : 1
        }
      },
      deep: true
    }
  },
  data() {
    return {
      channelIndex: 0,
      file: [],
      tableList: [],
      showAllNone: false,
      dialogWeekVisible: false,
      model: {
        tipsTempId: undefined,
        tipsDetail: '',
        dateType: 0,
        trackType: 1,
        batchTimeList: []
      },
      excelDateList: [], // 表格上传的日期
      weekPeriodList: [], // 按工作日/周末拆分的时段
      extendParamType: 0,
      isChangeModel: false,
      loading: false,
      channelIdList: [],
      eventOptions,
      curDateList: [],
      batchTimeListRules: {
        timeDay: [
          { required: true, message: '请选择投放时间', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const ind = rule.field.split('.')[1]
              const index = rule.field.split('.')[3]
              if (this.model.dateType === 1 && this.model.batchTimeList[ind].some(item => !item.timeList.timeHours)) {
                return callback(new Error('投放时间段不完整'))
              }
              if (checkPutTime(this.model.batchTimeList[ind].timeList)) {
                return callback(new Error('选择的时间有重复'))
              }
              if (this.periodCheck(this.model.batchTimeList[ind].timeList, ind, index)) {
                return callback(new Error('不能改变计划单原有投放日期'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      pickerOptions: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 8.64e7;
        }
      },
      eventTempList: [],
    }
  },
  computed: {
    showTargetEvent() {
      return this.baseInfo.targetEvent === 1 && this.getUploadStatus()
    },
    trackTypeList() {
      if (!this.baseInfo.trackTypeList) {
        return []
      }
      return (this.baseInfo.trackTypeList || []).filter(item => {
        return item.sub && item.sub.length
      })
    },
    trackTypeDisable() {
      return this.trackTypeList.length === 1 || this.loading || this.file.length > 0
    },
    trackTypeTips() {
      if (this.trackTypeList.length === 1) {
        return this.model.trackType === 1 ? '已选广告位不支持服务端监测' : '已选广告位不支持客户端监测'
      }
      return ''
    }
  },
  async created() {
    this.eventTempList = await this.$service.getTargetTemp({})
  },
  methods: {
    handleSelectPeriod(data) {
      const weekPeriodList = []
      let weekdays = []
      data.forEach((item, index) => {
        const periodArr = item.xSummarylist.map(i => {
          let time = i.split(' - ')
          let startTime = time[0] + ':00'
          let endTime = time[1] + ':00'
          if (time[1] === '24:00') {
            endTime = '23:59:59'
          } else {
            endTime = time[1] + ':00'
          }
          return [startTime, endTime]
        })
        const pIndex = weekPeriodList.findIndex(week => {
          return periodArr.length === week.periods.length &&
            week.periods.every((p, i) => {
              return periodArr[i][0] === p[0] && periodArr[i][1] === p[1]
            })
        })
        if (pIndex > -1) {
          weekPeriodList[pIndex].weekdays.push(item.yvalue + 1)
        } else {
          weekPeriodList.push({
            periods: periodArr,
            weekdays: [item.yvalue + 1],
            weekDates: []
          })
        }
        weekdays.push(item.yvalue + 1)
      })
      const fullweekdays = [1, 2, 3, 4, 5, 6, 7].filter(day => !weekdays.includes(day))
      if (fullweekdays.length) {
        weekPeriodList.push({
          periods: [['00:00:00', '23:59:59']],
          weekdays: fullweekdays,
          weekDates: []
        })
      }
      // [{ periods: [['00:00:00', '02:59:59'], ['08:00:00' , '09:59:59']], weekdays: [1, 2], weekDates: [] }]
      this.weekPeriodList = weekPeriodList
    },
    savePeriodTime() {
      this.excelDateList.forEach((sheet, index) => {
        if (index === this.channelIndex) {
          const allDayArr = sheet.batchTime.timeList.map(item => {
            return getBetweenDate(item.beginTime.slice(0, 10), item.endTime.slice(0, 10))
          })
          // [['2024-02-01', '2024-02-02', '2024-02-03', '2024-02-04', '2024-02-05'], ['2024-02-09', '2024-02-10']]
          allDayArr.forEach(days => {
            const startDate = moment(days[0]); // 开始日期
            const endDate = moment(days[days.length - 1]) // 结束日期
            let currentDate = startDate // 当前日期
            while (currentDate <= endDate) { // 遍历每天直到结束日期
              const weekPeriodIndex = this.weekPeriodList.findIndex(week => {
                const weekday = currentDate.day() === 0 ? 7 : currentDate.day()
                return week.weekdays.includes(weekday)
              })
              if (weekPeriodIndex > -1) {
                this.weekPeriodList[weekPeriodIndex].weekDates.push(currentDate.format('YYYY-MM-DD'))
              }
              currentDate = currentDate.add(1, 'days')
            }
          })
        }
      })
      let timeList = []
      this.weekPeriodList.forEach(item => {
        const continueDayList = dateSplitList(item.weekDates)
        continueDayList.forEach(days => {
          let timeDay = days.length === 1 ? [days[0], days[0]] : [days[0], days[days.length - 1]]
          item.periods.forEach(timeHours => {
            timeList.push({ timeDay, timeHours })
          })
        })
      })
      timeList.sort((prev, next) => moment(prev.timeDay[0]).unix() - moment(next.timeDay[0]).unix())
      this.model.batchTimeList[this.channelIndex].timeList = timeList
      this.dialogWeekVisible = false
    },
    weekHandle(ind) {
      this.channelIndex = ind
      this.dialogWeekVisible = !this.dialogWeekVisible
    },
    // 不能改变计划单原有投放日期
    periodCheck(timeList, ind, index) {
      let oldTimeDay = this.model.batchTimeList[ind].batchTime.timeList.map(item => {
        return getBetweenDate(item.beginTime.slice(0, 10), item.endTime.slice(0, 10))
      })
      let nowTimeDay = timeList.map(item => {
        return getBetweenDate(item.timeDay[0], item.timeDay[1])
      })
      let oldAllDays = Array.from(new Set(flatten(oldTimeDay))).sort().toString()
      let nowAllDays = Array.from(new Set(flatten(nowTimeDay))).sort().toString()
      return oldAllDays !== nowAllDays
    },
    validateHandle() {
      this.$refs.creativeForm.validate().catch(() => {})
    },
    dateTypeHandle(e) {
    },
    // 添加时间，如果有空的时间，则不允许添加
    handleAddTimePicker(ind) {
      this.model.batchTimeList[ind].timeList.push({
        timeDay: [],
        timeHours: ['00:00:00', '23:59:59']
      })
    },
    // 删除投放时间
    handleDeleteTimePicker(ind, index) {
      if (this.model.batchTimeList[ind].timeList.length === 1) {
        this.model.batchTimeList[ind].timeList[index].timeDay = []
        this.model.batchTimeList[ind].timeList[index].timeHours = []
      } else {
        this.model.batchTimeList[ind].timeList.splice(index, 1)
      }
    },
    // 投放时间变化
    handleInputPutTime(ind, index, val) {
      this.$set(this.model.batchTimeList[ind].timeList[index], 'timeDay', val)
    },
    getTargetEvent() {
      return {
        shipType: 'NONE',
        targetEventType: 4, // 交互事件类型，默认4-无交互事件
        targetEvent: genTargetEvent()
      }
    },
    handleShipTypeChange(val) {
      if (val === 'NONE') {
        this.model.targetEvent = genTargetEvent()
        this.handleTargetEventChange(4)
      }
      this.model.clickButtonContent = ''
    },
    handleBackupShipTypeChange(val) {
      if (val === 'NONE') {
        this.model.backupTargetEvent = genTargetEvent()
      }
    },
    filterDefaultTips(tipsList) {
      if (tipsList && tipsList.length) {
        const filteredList = tipsList.filter(item => [4, 3, undefined].includes(item.relatedTargetType))
        return filteredList.length ? JSON.stringify(filteredList) : ''
      }
      return ''
    },
    handleTargetEventChange(targetEventType) {
      const model = this.model
      model.targetEventType = targetEventType
      if (model.tipsTempId === undefined && model.tipsDetail !== '') {
        this.$alert('由于交互事件类型变更，提示语将清空，请重新设置', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            this.model.tipsTempId = undefined
            this.model.tipsDetail = ''
          }
        })
      }
    },
    saveTips(data) {
      this.model.tipsTempId = data.tipsTempId
      this.model.tipsDetail = data.tipsDetail
    },
    changeFile(file, fileList) {
      if (file.status === 'ready') {
        this.loading = true
      }
      if (file.status === 'success') {
        this.loading = false
      }
    },
    handleUploadSuccess(data, file) {
      // 每次都把最新的文件替换
      this.file = []
      this.file.push(file)
      if (data.code === 0) {
        this.tableList = []
        const excelList = data.data
        this.model = {
          ...this.model,
          ...this.uploadInfo,
          shipType: 'NONE',
          targetEventType: 4,
          targetEvent: genTargetEvent(),
          backupShipType: 'NONE',
          backupTargetEvent: genTargetEvent(),
          creativeTitle: '',
          clickButtonContent: '',
          tipsTempId: this.model.tipsTempId,
          tipsDetail: this.model.tipsDetail
        }
        this.model.fileName = excelList[0].fileName
        this.model.extendParamType = this.extendParamType
        excelList.forEach((list, t) => {
          if (list.code === 0) {
            this.loading = false
            // 表格解析成功
            // const scheduleTimeIndex = list.excelHead.scheduleTimeList
            const excelBodyList = list.excelBodyList
            const dataMap = excelBodyList.map(item => {
              return {
                scheduleName: item.scheduleName,
                erpSubOrder: item.erpSubOrder,
                suborderNo: item.suborderNo,
                dealId: item.dealId,
                provinceStr: item.provinceStr,
                cityStr: item.cityStr,
                frequencyName: item.frequencyName,
                frequency: item.frequency,
                seq: item.seq,
                payTotalTraffic: item.payTotalTraffic,
                freeTotalTraffic: item.freeTotalTraffic,
                addedTotalTraffic: item.addedTotalTraffic,
                mediaIdStr: item.mediaIdStr,
                mateCheckCodeStr: item.mateCheckCodeStr,
                defaultMediaIdStr: item.defaultMediaIdStr,
                totalTraffic: item.totalTraffic,
                trafficTypeStr: item.trafficTypeStr,
                trafficTypeValue: item.trafficTypeValue,
                autoFillingStr: item.autoFillingStr,
                cashTrackType: item.cashTrackType,
                cashProviderName: item.cashProviderName,
                scheduleNo: item.scheduleNo,
                unionFrequency: item.unionFrequency,
                subUnionFrequency: item.subUnionFrequency,
                unionOrderStr: item.unionOrderStr,
                subFrequencyName: item.subFrequencyName,
                subFrequency: item.subFrequency,
                sellingPrice: item.sellingPrice,
                billTypeStr: item.billTypeStr,
                taCondition: item.taCondition,
                uvTarget: item.uvTarget,
                uvPercentage: item.uvPercentage,
                autoAdd: ['否', '是'][item.autoAdd] || ''
              }
            })
            const scheduleTraffic = this.getScheduleTraffic('schedule', list.excelHead, excelBodyList, dataMap)
            const scheduleDayData = scheduleTraffic.data;
            const scheduleHeader = [...scheduleTraffic.month]

            const extraTraffic = this.getScheduleTraffic('extra', list.excelHead, excelBodyList, dataMap)
            const extraDayData = extraTraffic.data;
            const extraDayHeader = [...extraTraffic.month]

            const addedTraffic = this.getScheduleTraffic('added', list.excelHead, excelBodyList, dataMap)
            const addedDayData = addedTraffic.data;
            const addedDayHeader = [...addedTraffic.month]
            // const scheduleTimeHeader = scheduleTimeIndex.map((t, index) => {
            //   return {
            //     title: index % 2 ? '结束' : '开始',
            //     prop: 'begin' + index
            //   }
            // })

            excelBodyList.forEach((item, i) => {
              // item.scheduleTimeList.forEach((t, index) => {
              //   dataMap[i]['begin' + index] = t
              // })

              item.showTrackList.map((list, index) => {
                // eslint-disable-next-line no-unused-expressions
                (dataMap[i]['show' + [index + 1] + 'serviceProvider'] =
                    // eslint-disable-next-line no-sequences
                    list.serviceProvider),
                (dataMap[i]['show' + [index + 1] + 'trackTypeModel'] =
                    list.trackTypeModel),
                (dataMap[i]['show' + [index + 1] + 'code'] = list.code)
              })
              // dataMap[i].showTrackList = item.showTrackList
              item.clickTrackList.forEach((list, index) => {
                // eslint-disable-next-line no-unused-expressions
                (dataMap[i]['click' + [index + 1] + 'serviceProvider'] =
                  // eslint-disable-next-line no-sequences
                  list.serviceProvider),
                (dataMap[i]['click' + [index + 1] + 'trackTypeModel'] =
                    list.trackTypeModel),
                (dataMap[i]['click' + [index + 1] + 'code'] = list.code)
              })
              item.endPlayTrackList.forEach((list, index) => {
                // eslint-disable-next-line no-unused-expressions
                ;(dataMap[i]['end' + [index + 1] + 'serviceProvider'] =
                  // eslint-disable-next-line no-sequences
                  list.serviceProvider),
                (dataMap[i]['end' + [index + 1] + 'trackTypeModel'] =
                    list.trackTypeModel),
                (dataMap[i]['end' + [index + 1] + 'code'] = list.code)
              })
              item.startPlayTrackList.forEach((list, index) => {
                // eslint-disable-next-line no-unused-expressions
                (dataMap[i]['start' + [index + 1] + 'serviceProvider'] =
                  // eslint-disable-next-line no-sequences
                  list.serviceProvider),
                (dataMap[i]['start' + [index + 1] + 'trackTypeModel'] =
                    list.trackTypeModel),
                (dataMap[i]['start' + [index + 1] + 'code'] = list.code)
              })
              item.centerPlayTrackList.forEach((list, index) => {
                // eslint-disable-next-line no-unused-expressions
                (dataMap[i]['center' + [index + 1] + 'serviceProvider'] =
                  // eslint-disable-next-line no-sequences
                  list.serviceProvider),
                (dataMap[i]['center' + [index + 1] + 'trackTypeModel'] =
                    list.trackTypeModel),
                (dataMap[i]['center' + [index + 1] + 'code'] = list.code)
              })
              item.pointPlayTrackList.forEach((list, index) => {
                // eslint-disable-next-line no-unused-expressions
                (dataMap[i]['point' + [index + 1] + 'serviceProvider'] =
                  // eslint-disable-next-line no-sequences
                  list.serviceProvider),
                (dataMap[i]['point' + [index + 1] + 'trackTypeModel'] =
                    list.trackTypeModel),
                (dataMap[i]['point' + [index + 1] + 'code'] = list.code),
                (dataMap[i]['point' + [index + 1] + 'point'] = list.point)
              })
            })
            this.tableList.push({
              sheetType: t,
              batchTime: list.batchTime,
              title:
                t === 0 ? '创维智能电视' : t === 1 ? '酷开OS' : t === 2 ? 'Q系统' : t === 3 ? '剩余流量表格' : 'QR系统',
              code: list.code,
              data: dataMap,
              message: list.tipMsgLst || [],
              scheduleDayData,
              scheduleHeader,
              extraDayData,
              extraDayHeader,
              addedDayData,
              addedDayHeader
            })
          } else if (list.code === 1) {
            this.loading = false
            // 解析错误
            this.tableList.push({
              title:
                t === 0 ? '创维智能电视' : t === 1 ? '酷开OS' : t === 2 ? 'Q系统' : t === 3 ? '剩余流量表格' : 'QR系统',
              message: list.errorMsgLst,
              code: list.code
            })
          } else {
            this.loading = false
            // 表中无数据
            this.tableList.push({
              title:
                t === 0 ? '创维智能电视' : t === 1 ? '酷开OS' : t === 2 ? 'Q系统' : t === 3 ? '剩余流量表格' : 'QR系统',
              code: list.code
            })
          }
        })
        if (this.tableList.every(item => item.code === 2)) {
          this.showAllNone = true
        } else {
          this.showAllNone = false
        }
        this.channelIdList = []
        if ((this.tableList[0] && this.tableList[0].data) || (this.tableList[3] && this.tableList[3].data)) {
          this.channelIdList.push('skyworth_market')
        }
        if ((this.tableList[1] && this.tableList[1].data)) {
          this.channelIdList.push('coocaa_market')
        }
        if ((this.tableList[2] && this.tableList[2].data)) {
          this.channelIdList.push('PC0001')
        }
        if ((this.tableList[4] && this.tableList[4].data)) {
          this.channelIdList.push('PC0003')
        }
        this.isChangeModel = false
        this.model.batchTimeList = this.tableList.filter((item, index) => item.code === 0 && item.batchTime).map(item => {
          let timeList = (item.batchTime.timeList || []).map(it => {
            let timeHours = ['00:00:00', '23:59:59']
            let timeDay = it.beginTime && it.endTime ? [it.beginTime.slice(0, 10), it.endTime.slice(0, 10)] : []
            return { timeHours, timeDay }
          })
          return {
            sheetType: item.sheetType,
            title: item.title,
            timeList: timeList,
            batchTime: item.batchTime,
            dateType: item.batchTime.dateType || 0
          }
        })
        this.excelDateList = this.cloneDeep(this.model.batchTimeList)
      }
    },
    getScheduleTraffic(type, excelHeader = [], excelBodyList, dataMap) {
      let arr = []
      let months = new Set()
      let dayType = ''
      let dateList = []
      let monthIndex = {}
      let dayIndex = {}
      if (type === 'schedule') {
        dayType = 'scheduleDayList'
        dateList = excelHeader.scheduleDateList
        monthIndex = excelHeader.yearMonthMap
        dayIndex = excelHeader.dayMap
      } else if (type === 'extra') {
        dayType = 'extraDayList'
        dateList = excelHeader.extraDateList
        monthIndex = excelHeader.extraYearMonthMap
        dayIndex = excelHeader.extraDayMap
      } else if (type === 'added') {
        dayType = 'addedDayList'
        dateList = excelHeader.addedDateList
        monthIndex = excelHeader.addedYearMonthMap
        dayIndex = excelHeader.addedDayMap
      }
      dateList.forEach((item, index) => {
        const month = monthIndex[item]
        const day = dayIndex[item]
        dataMap.forEach((e, i) => {
          e[type + month + day] = excelBodyList[i][dayType][index] || 0
        })
        months.add(month)
        arr.push({
          'month': month,
          'day': day
        })
      })
      return { data: arr, month: months }
    },
    handleBeforeRemove() {
      this.file = []
      this.channelIdList = []
      this.tableList = []
      return true
    },
    previous() {
      this.$emit('previous', 0)
    },
    async next() {
      if (this.getUploadStatus(true)) {
        const isValid = await this.$refs.creativeForm.validate().catch(() => {})
        if (!isValid) return false
        const params = this.cloneDeep(this.model)
        const excelInfo = {
          channelIdList: this.channelIdList,
          ...this.baseInfo
        }
        if (excelInfo.spaceNo === 'CCADTV10001' && !params.tipsDetail) {
          return this.$message.error('开机广告提示语必填')
        }
        params.batchTimeList.forEach(item => {
          if (item.dateType === 0) {
            item.timeList = item.batchTime.timeList
          } else if (item.dateType === 1) {
            item.timeList = handleFormTimeList(item.timeList)
          }
          delete item.title
          delete item.batchTime
        })
        params.tipsTempId = params.tipsDetail === '' ? undefined : -1
        params.keyEventList = params.shipType === 'KEY' ? [params.targetEvent] : [genTargetEvent()]
        params.voiceEventList = params.shipType === 'VOICE' ? [params.targetEvent] : [genTargetEvent()]
        params.autoEventList = params.shipType === 'AUTO' ? [params.targetEvent] : [genTargetEvent()]
        params.clickButtonContent = (params.shipType === 'KEY' && params.targetEvent && params.targetEvent.targetTempId > -1) ? params.clickButtonContent : undefined
        if (this.baseInfo.targetEvent === 1 && this.uploadInfo.supportMode === 2) {
          params.backupKeyEventList = params.backupShipType === 'KEY' ? [params.backupTargetEvent] : [genTargetEvent()]
          params.backupVoiceEventList = params.backupShipType === 'VOICE' ? [params.backupTargetEvent] : [genTargetEvent()]
          params.backupAutoEventList = params.backupShipType === 'AUTO' ? [params.backupTargetEvent] : [genTargetEvent()]
        }
        // 判断关联频控次数与计划单频次是否一致
        let flag = false
        let tips = []
        this.tableList.forEach(item => {
          let tip = [];
          (item.data || []).forEach((it, ind) => {
            if (it.unionOrderStr === '否' && it.frequency && it.unionFrequency && it.frequency !== it.unionFrequency) {
              tip.push(`第${ind + 1}行`)
              flag = true
            }
          })
          if (tip.length > 0) {
            tips.push(`${item.title}:${tip.join('、')}`)
          }
        })
        if (flag) {
          this.$confirm(tips.join(';') + '关联频控次数与计划单频次不一致，是否确认保存提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$emit('next', 2, params, excelInfo)
            })
            .catch(() => {
            })
        } else {
          this.$emit('next', 2, params, excelInfo)
        }
      }
    },
    getUploadStatus(showMessage) {
      if (!this.isChangeModel) {
        if (this.tableList.length > 0) {
          const isHaveError = this.tableList.some(item => item.code === 1)
          if (isHaveError) {
            showMessage && this.$message.error('表格数据校验不通过！')
          } else {
            if (this.tableList.every(item => item.code === 2)) {
              showMessage && this.$message.error('表格中未包含任何排期，请重新上传！')
            } else {
              return true
            }
          }
        } else {
          showMessage && this.$message.error('请先上传计划表格！')
        }
      } else {
        showMessage && this.$message.error('基础信息有修改，请重新上传表格校验！')
      }
      return false
    },
    handleExtendParamChange(val) {
      this.model.extendParamType = val
    }
  },
  mounted() {}
}

</script>
<style lang="stylus" scoped>
  .time-line {
    margin-left: 20px;
  }
  .preview {
    display flex
    .pre-tit {
      width 50px;
      text-align right;
      padding-right: 10px;
    }
  }
  .selIcon {
    cursor pointer
    margin-right 10px
    font-size 20px
    color #ff8b00
  }
  .flex-form-item
    display flex
    .form-item-select
      width 250px
      padding-left 10px
  .c-date-picker
    width 250px
    margin-right 10px
  .demo-ruleForm-box .demo-ruleForm-half-select,.demo-ruleForm-half-picker
    width 231px
  .remark-tip {
      min-width:317px;
      height:22px;
      font-size:12px;
      font-weight:400;
      color:rgba(0,0,0,0.45);
      line-height:22px;
      padding-left 8px
    }
  .box-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24px;
    line-height: 24px;
    padding: 16px 0 15px 23px;
    width: 100%;
  }
  >>>.el-table--border td,>>>.el-table--border th,>>>.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed
   border-right 1px solid #ebeef5
  >>>.el-table--border, >>>.el-table--group
    border 1px solid #ebeef5
    border-right: none
  .table-search
    display flex
    justify-content flex-end
    margin 10px 0
    .el-input
      width 280px
  .video-table
    border-right 1px solid #eee
  .dialog-footer
    padding-bottom 10px
    text-align center
    .el-button+.el-button
      margin-left 80px
</style>

<style lang="stylus">
.period-dialog
  .el-dialog__body
    padding 10px 20px
  .el-dialog__header
    padding 12px 20px 10px
    border-bottom 1px solid #dce1e6
</style>
